import styled, { css } from 'react-emotion';
import theme from '@lyearn-team/theme-config';

export const CompanyPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: center;
  box-sizing: border-box;
  &.pageWrapper {
    @media (min-width: 767px) {
      width: 503px;
      height: 603px;
    }
    background-color: ${theme.color.dark.saturn};
    padding: 53px 55px 24px;
    @media (max-width: 767px) {
      padding: 80px 16px 20px;
      width: 100%;
      height: 100%;
    }
  }
`;

export const ContactLyearnText = styled.div`
  font-size: 12px;
  line-height: 17px;
  margin: 40px 0 0;
  text-align: center;
  width: 100%;
  color: ${theme.color.dark.iron};
  a {
    cursor: pointer;
    text-decoration: underline;
    color: ${theme.color.dark.amethyst};
    :hover {
      color: ${theme.color.dark.iron};
    }
  }

  @media (max-width: 767px) {
    margin: 40px 0 0px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const FixWidthColumn = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 393px;
  margin-top: 74px;
  align-items: center;
  @media (max-width: 767px) {
    margin-top: 60px;
    width: 100%;
    flex-grow: 1;
    justify-content: space-between;
  }
`;

export const SetNewPasswordInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 393px;
`;

export const passwordWrapperClass = css`
  margin-bottom: 12px;
  width: 100%;
`;

export const inputClass = css`
  width: 100%;
  margin-bottom: 12px;
  padding: 10px 20px;

  @media (max-width: 767px) {
    text-align: left;
  }
`;

export const passwordInputClass = css`
  width: 100%;
  padding: 10px 20px;
`;

export const buttonClass = css`
  width: 100%;
  margin: 10px 0 0 0;
  line-height: 16px;
  padding: 10px 16px;

  @media (max-width: 767px) {
    text-align: left;
    width: 100%;
  }
`;

export const validationMsgClass = css`
  color: ${theme.color.dark.silver};
  font-size: 10px;
  padding: 14px 0 0 0;
  text-align: left;
  float: left;
  align-self: flex-start;
  @media (max-width: 767px) {
    font-size: 12px;
  }
`;
export const greenMsgClass = css`
  color: #39b54a !important;
`;

export const checkRightClass = css`
  float: left;
  padding: 13px 0 0 12px;
`;

export const msgDivClass = css`
  width: 100%;
  display: inline;
  line-height: 15px;
`;

export const GlobalMessage = styled.div`
  color: ${theme.color.dark.ruby};
  font-size: 14px;
  line-height: 14px;
  margin: 10px 0 0px;
  ${/* a {
    cursor: pointer;
    text-decoration: underline;
    color: ${color.black3};
    :hover {
      color: ${color.black2};
    }
  } */ ''}
`;
